import { get, ref } from 'firebase/database'
import { db } from '../../../../firebase/configs'
import {
    BookingTerm,
    SchoolBookingType,
} from '../../../../firebase/types-bookings'
import { Dayjs } from 'dayjs'
import { IconButton, Skeleton, styled, Typography } from '@mui/material'
import styles from './index.module.scss'
import pxToRem from '../../../../helpers/pxToRem'
import { BookingStatusCellType } from './tableComponents/BookingStatusCell'
import { TeacherSimpleData } from '../../../../firebase/school-api'
import { WorkingDay } from '../../hooks/useCalendarDates'

export type BookingRow = {
    // Original values from school placement key
    placementUid: string
    date: string
    calendarDate?: WorkingDay
    dateObj: Dayjs
    teacherUid: string

    esBooking?: boolean
    cancelled?: boolean
    replaced?: string

    // Derived values
    // teacherName: string
    teacherData: TeacherSimpleData
    bookingType: SchoolBookingType | null
    bookingTerm: BookingTerm | null
    // NOTE: Need to check if we have this data in placements?
    bookingSubject: string | null
    bookingReplacing: string | null
    bookingStatus: BookingStatusCellType | null
}

export type BookingTableData = Pick<
    BookingRow,
    | 'bookingType'
    | 'bookingTerm'
    | 'bookingSubject'
    | 'bookingReplacing'
    | 'bookingStatus'
> & {
    id: string
}

export const fetchBookingType = async (
    dateObj: Dayjs,
    placementUid: string,
    config: { country: string; locationState: string }
) => {
    try {
        return (
            await get(
                ref(
                    db,
                    `countries/${config.country}/${
                        config.locationState
                    }/placements/confirmed/${dateObj.format(
                        'YYYY'
                    )}/${dateObj.format('MM')}/${dateObj.format(
                        'DD-MM-YYYY'
                    )}/${placementUid}/placementDetails/type`
                )
            )
        ).val() as SchoolBookingType | null
    } catch (e) {
        return null
    }
}

export type IBookingsCell = {
    setValue?: (value: any) => void
    width?: number
}

export const BookingsTableActionButton = styled(IconButton)({
    backgroundColor: styles.neutrals50,
})

export const CountFont = styled(Typography)(({theme}) => ({
    textAlign: 'center',
    fontWeight: 600,
    ...theme.typography.h6
}))

export const TableSkeleton = styled(() => (
    <Skeleton variant="rectangular" height={pxToRem(150)} />
))({
    width: '100%',
})

export const TableTitleFont = styled(Typography)({
    color: styles.shades100,

    fontSize: pxToRem(20),
    fontWeight: 600,
    lineHeight: pxToRem(28),
    letterSpacing: pxToRem(-0.4),
})
export const TableSubtitleFont = styled(() => (
    <Typography className={styles.tableSubtitle} />
))({
    color: styles.neutrals500,

    fontSize: pxToRem(12),
    fontWeight: 400,
    lineHeight: pxToRem(20),
    letterSpacing: pxToRem(-0.24),
})

export const EmptyTablePlaceholderFont = styled(Typography)(({ theme }) => ({
    color: styles.neutrals500,
    ...theme.typography.ps,
    // fontSize: pxToRem(14),
    // fontWeight: 400,
    // letterSpacing: pxToRem(-0.28),
    // lineHeight: pxToRem(20),
}))

export const reverseDate = (date: string) => {
    const [dd, mm, yyyy] = date.split('-')
    return `${yyyy}-${mm}-${dd}`
}
export const unreverseDate = (date: string) => {
    const [yyyy, mm, dd] = date.split('-')
    return `${dd}-${mm}-${yyyy}`
}
